import styled from 'styled-components';

export const CircleCheckSpan = styled.span`
  background: rgb(25, 118, 210);
  border-radius: 50%;
  bottom: 5px;
  height: 24px;
  padding: 0;
  position: absolute;
  right: 5px;
  width: 24px;
`;

export const NoPhotosAvailableDiv = styled.div`
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  text-align: center;
`;

export const CircularProgressContainer = styled.div`
  display: flex;
  justify-content: center;
`;
